import clsx from "clsx";
import React from "react";
import { Margins, marginsClass } from "../Layout";
import css from "./page.module.scss";

export interface PageButtonProps extends React.ComponentProps<"button">
{
    margins?: Margins;
}

export const PageButton = ({ className, margins, ...props }: PageButtonProps): React.ReactComponentElement<"button", PageButtonProps> =>
{
    const classes = clsx(
        css["button"],
        marginsClass(margins),
        className
    );

    return <button type="button" {...props} className={classes} />;
}